import Skeleton from './skeleton';
import SkeletonV3 from './skeleton-v3';
import CarouselBannerMain from './carousel';
import CarouselBannerV3 from './carousel-v3';

const CarouselBannerSsr = props => {
  const { properties } = props;
  const isV3Banner = properties?.version === 'v3';

  const skeleton = isV3Banner ? <SkeletonV3 /> : <Skeleton version={properties?.version} {...props} />;

  if (isV3Banner) {
    return <CarouselBannerV3 skeleton={skeleton} {...props} />;
  }
  return <CarouselBannerMain skeleton={skeleton} {...props} />;
};

export default CarouselBannerSsr;
